<div class="cart-item-row">
  <div class="cart-item-row__icon" aria-hidden="true">
    @if (item().logoUrl; as url) {
      <img [src]="url" alt="" />
    } @else {
      <span class="cart-item-row__icon-fallback icon-image-01"></span>
    }
  </div>
  <div class="cart-item-row__details">
    <div class="cart-item-row__top">
      <span class="cart-item-row__name text-xs-bold text-secondary-hover">{{
        item().productName
      }}</span>
      <span class="cart-item-row__value text-sm-bold text-tertiary"
        >{{ item().totalAmount | nttAmount }} {{ item().currencyName }}</span
      >
    </div>
    <div class="cart-item-row__bottom">
      <span class="cart-item-row__type text-xs-regular text-quaternary">{{
        item().productType
      }}</span>
      <span class="cart-item-row__qty text-xs-regular text-quaternary"
        >{{ item().quantity }} عدد</span
      >
    </div>
  </div>
</div>
